
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-f4cb52aa&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./serviceRepair.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./serviceRepair.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-f4cb52aa!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./serviceRepair.vue"),
  /* scopeId */
  "data-v-f4cb52aa",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/staging/serviceRepair.vue
// module id = 1579
// module chunks = 3